import React, { Component } from "react";
import { Col, Row, Container, Media } from "reactstrap";
import { joinCss } from "../../helpers/utils";
import { getFileLink } from "../../helpers/utils";

import fixImg from "../../images/fixPaper.png";
import editionImg from "../../images/editionSearch.png";

import PageResults from "./PageResults";
import ResultDataRow from "./ResultDataRow";

import appClasses from "../../App.module.scss";

class FileDetails extends Component {
  render() {
    const file = this.props.file;
    return (
      <div>
        <Row
          key={this.props.index}
          className={joinCss(
            appClasses.resultLine,
            "mb-4",
            appClasses["vertical-center-parent"]
          )}
        >
          <Container>
            <Row>
              <a
                className={appClasses.resultContantLink}
                target="_blank"
                href={getFileLink(file.docIdentity, file.pdfName)}
              >
                <Col lg="1" sm="2" className={appClasses.rightCol}>
                  <Media
                    className="px-1 pt-4"
                    src={file.docParentID === "" ? editionImg : fixImg}
                    alt="מסמך"
                  />
                  <div className={appClasses.imgTitle}>
                    {file.docParentID === "" ? "מהדורה" : "דף תיקון"}
                  </div>
                </Col>
              </a>
              <Col lg="11">
                <Row>
                  {file.pages.map((page, j) => {
                    return (
                      <PageResults
                        chapterText={this.props.name}
                        result={page}
                        index={j}
                        key={j}
                      ></PageResults>
                    );
                  })}
                </Row>
              </Col>
            </Row>
            <ResultDataRow resultsLength="0" publishAt={file.publishAt} />
          </Container>
        </Row>
      </div>
    );
  }
}

export default FileDetails;
